import { useCallback } from 'react';

import { EPaths } from 'router/const/paths';

import { useConferenceId } from 'hooks/useConferenceId';

import { searchParamsNames } from 'constants/searchParamsNames';

/** Хук вернет функцию для редиректа на страницу "Подготовка к конференции" */
export function useRedirectToPreparationPage() {
    const conferenceId = useConferenceId();

    return useCallback(() => {
        const searchParams = new URLSearchParams();

        searchParams.set(searchParamsNames.redirectTo, `/conference/${conferenceId}`);
        window.location.assign(`/${EPaths.PREPARATION}?${searchParams}`);
    }, [conferenceId]);
}
